import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
export const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: ["selected_variant_id"],
    }),
  ],
  state: {
    selected_variant_id: 1,
    variants: [
      {
        id: 1,
        name: "Freesia",
        imgSrc: require("@/assets/variants/freesia.png"),
        thumbnail: require("@/assets/products/freesia.png"),
        thumbnailAlt: require("@/assets/products/freesia-alt.png"),
        galleryItems: [
          require("@/assets/fold3/Freesia.jpg"),
          require("@/assets/fold3/Freesia1.jpg"),
        ],
        price: 2499000,
        priceDiscounted: 2149000,
      },
      {
        id: 2,
        name: "Orchid",
        imgSrc: require("@/assets/variants/orchid.png"),
        thumbnail: require("@/assets/products/orchid.png"),
        thumbnailAlt: require("@/assets/products/orchid-alt.png"),
        galleryItems: [
          require("@/assets/fold3/Orchid.jpg"),
          require("@/assets/fold3/Orchid1.jpg"),
        ],
        price: 2499000,
        priceDiscounted: 2149000,
      },
      {
        id: 3,
        name: "Rose",
        imgSrc: require("@/assets/variants/rose.png"),
        thumbnail: require("@/assets/products/rose.png"),
        thumbnailAlt: require("@/assets/products/rose-alt.png"),
        galleryItems: [
          require("@/assets/fold3/Rose.jpg"),
          require("@/assets/fold3/Rose1.jpg"),
        ],
        price: 2499000,
        priceDiscounted: 2149000,
      },
      {
        id: 4,
        name: "Dahlia",
        imgSrc: require("@/assets/variants/dahlia.png"),
        thumbnail: require("@/assets/products/dahlia.png"),
        thumbnailAlt: require("@/assets/products/dahlia-alt.png"),
        galleryItems: [
          require("@/assets/fold3/Dahlia.jpg"),
          require("@/assets/fold3/Dahlia1.jpg"),
        ],
        price: 2499000,
        priceDiscounted: 2149000,
      },
      {
        id: 5,
        name: "Ivy",
        imgSrc: require("@/assets/variants/ivy.png"),
        thumbnail: require("@/assets/products/ivy.png"),
        thumbnailAlt: require("@/assets/products/ivy-alt.png"),
        galleryItems: [
          require("@/assets/fold3/Ivy.jpg"),
          require("@/assets/fold3/Ivy1.jpg"),
        ],
        price: 2499000,
        priceDiscounted: 2149000,
      },
    ],
  },
  getters: {
    selectedVariant: (state) => {
      return (
        state.variants.find(
          (variant) => variant.id == state.selected_variant_id
        ) ?? state.variants[0]
      );
    },
  },
  mutations: {
    selectVariant(state, id) {
      state.selected_variant_id = id;
    },
  },
});
